import React from 'react';

interface EmailConfirmationText {
  title: string;
  heading: string;
  securityNotice: string;
  confirmationNotice?: string;
  emailInstruction?: string;
  emailHighlight?: string;
  closeButton: string;
  closeButtonHint?: string;
  resendButton?: string;
  editButton?: string;
}

interface EmailConfirmationModalProps {
  isOpen: boolean;
  text: EmailConfirmationText;
  newEmail?: string;
  currentEmail?: string;
  onClose: () => void;
  onResend?: () => void;
  onEdit?: () => void;
}

const ConfirmationModal: React.FC<EmailConfirmationModalProps> = ({
  isOpen,
  text,
  onClose,
  onResend,
  onEdit,
  newEmail,
  currentEmail,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center bg-black/50 backdrop-blur-sm px-4 pt-20">
      <div
        className="w-full max-w-sm bg-white rounded-2xl shadow-xl p-4 text-gray-900 relative animate-fade-in"
        onClick={e => e.stopPropagation()}
      >
        <h2 className="text-secondary font-ambit text-xl font-black leading-[25px] mb-4">
          {text.title}
        </h2>

        <h2 className="inline-block mb-4 relative text-secondary font-ambit text-[35px] font-ambit leading-[40px]">
          {text.heading}
          {(currentEmail || newEmail) && (
            <span className="underline decoration-solid decoration-[1px] underline-offset-[3px]">
              {currentEmail || newEmail}
            </span>
          )}
        </h2>

        <p className="text-sm text-gray-700 mb-2">{text.securityNotice}</p>

        {text.confirmationNotice && (
          <p className="text-sm text-gray-700 mb-2">{text.confirmationNotice}</p>
        )}

        {(text.emailInstruction || text.emailHighlight) && (
          <p className="text-sm text-gray-700 mb-4">
            {text.emailInstruction}{' '}
            {text.emailHighlight && (
              <span className="text-secondary font-ambit text-base font-bold">
                {text.emailHighlight}
              </span>
            )}
            .
          </p>
        )}

        <div className="space-y-3">
          <button
            onClick={onClose}
            className="w-full bg-primary text-white py-2 px-4 rounded-full font-medium"
          >
            {text.closeButton}{' '}
            {text.closeButtonHint && (
              <span className="text-sm font-light">({text.closeButtonHint})</span>
            )}
          </button>

          {text.resendButton && onResend && (
            <button
              onClick={onResend}
              className="w-full border border-gray-400 text-gray-800 py-2 px-4 rounded-full font-medium hover:bg-gray-50"
            >
              {text.resendButton}
            </button>
          )}

          {text.editButton && onEdit && (
            <button
              onClick={onEdit}
              className="w-full text-secondary underline text-base font-bold"
            >
              {text.editButton}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
